import React, { memo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import packageJson from "../../package.json";
import iconLogout from "assets/images/pages/icon-signout.png";
import logo from "assets/images/pages/logo_white.png";
import pathnames from "routes/pathnames";
import { useHistory } from "react-router-dom";
import CONSTANSTS from "common/constansts";
import "../../node_modules/jquery/dist/jquery.min.js";
import "../../node_modules/bootstrap/dist/js/bootstrap.min.js";

const AppNav = memo(({ logoutToggle }) => {
  const [loanMenu, setLoanMenu] = useState("");
  const [databaseMenu, setDatabaseMenu] = useState("");
  const [reportsMenu, setReportsMenu] = useState("");
  const [adminMenu, setAdminMenu] = useState("");
  const [userMenu, setUserMenu] = useState("");
  const [navBrand, setNavBrand] = useState("");
  const [calendar, setCalendar] = useState("");

  const history = useHistory();

  const menuClicked = (e) => {
    console.log("current path: ", window.location.href);
    var menu = "";
    menu = e;
    if (menu === "loan") {
      setLoanMenu("selected");
      setDatabaseMenu("");
      setReportsMenu("");
      setAdminMenu("");
      setUserMenu("");
      setCalendar("");
      document.getElementById("navbarSupportedContent").classList.remove('show');
    } else if (menu === "database") {
      setLoanMenu("");
      setDatabaseMenu("selected");
      setReportsMenu("");
      setAdminMenu("");
      setUserMenu("");
      setCalendar("");
      document.getElementById("navbarSupportedContent").classList.remove('show');
    } else if (menu === "report") {
      setLoanMenu("");
      setDatabaseMenu("");
      setReportsMenu("selected");
      setAdminMenu("");
      setUserMenu("");
      setCalendar("");
      document.getElementById("navbarSupportedContent").classList.remove('show');
      sessionStorage.removeItem("searchBulk");
    } else if (menu === "admin") {
      setLoanMenu("");
      setDatabaseMenu("");
      setReportsMenu("");
      setAdminMenu("selected");
      setUserMenu("");
      setCalendar("");
      document.getElementById("navbarSupportedContent").classList.remove('show');
    } else if (menu === "user") {
      setLoanMenu("");
      setDatabaseMenu("");
      setReportsMenu("");
      setAdminMenu("");
      setUserMenu("selected");
      setCalendar("");
      document.getElementById("navbarSupportedContent").classList.remove('show');
      history.push(pathnames.pageUserProfile);
    }else if (menu === "home") {
      setNavBrand("select");
      setLoanMenu("");
      setDatabaseMenu("");
      setReportsMenu("");
      setAdminMenu("");
      setUserMenu("");
      setCalendar("");
      document.getElementById("navbarSupportedContent").classList.remove('show');
      
      // refresh page only when user is in homepage and clicked the top-left icon
      if (window.location.href.includes("home-page")) {
        history.push(pathnames.pageHomePage);
        window.location.reload();
      } else if (window.location.href.includes("loan-contract-view")) {
        history.push(pathnames.pageHomePage, 'contract-view');
      } else {
        history.push(pathnames.pageHomePage);
      }
    }else if (menu === "calendar") {
      setNavBrand("");
      setLoanMenu("");
      setDatabaseMenu("");
      setReportsMenu("");
      setAdminMenu("");
      setUserMenu("");
      setCalendar("selected");
      history.push(pathnames.pageCalendarSettings);
      document.getElementById("navbarSupportedContent").classList.remove('show');
    }
    else {
      setLoanMenu("");
      setDatabaseMenu("");
      setReportsMenu("");
      setAdminMenu("");
      setUserMenu("");
      setCalendar("");
    }
  };

  const nav = {
    loan: false,
    database: false,
    reports: false,
    admin: false,
    profile: false,
  };

  const [isAuthorities, setIsAuthorities] = useState(false);
  const [roles, setRoles] = useState(false);
  const [userMatrix, setUserMatrix] = useState(nav);
  const [viewList, setViewList] = useState({
    view_loan_list: false,
    view_contract_list: false,
  });

  useEffect(() => {
    const authorities = localStorage.getItem("decode_token");
    let userMatrixList = null;
    userMatrixList = localStorage.getItem("accessMatrix");
    const userAccess = JSON.parse(userMatrixList);
    // console.log("userAccess", userAccess.accessMatrix);
    setRoles(authorities);

    if (authorities === CONSTANSTS.ROLES.superAdmin || authorities === CONSTANSTS.ROLES.masterAdmin || authorities === CONSTANSTS.ROLES.executive) {
      setIsAuthorities(true);
    } else {
      setIsAuthorities(false);
    }
    if (userMatrixList) {
      setUserMatrix({
        admin: userAccess.accessMatrix.Admin_Setting.view_dropdown,
      });
      setViewList({
        view_loan_list: userAccess.accessMatrix.Loan_Application_List.view_loan_list,
        view_contract_list: userAccess.accessMatrix.Loan_Contract_List.view_contract_list,
      });
    }
  }, []);

  return (
    // <nav className="nav-bar">
    //   <Link to={pathnames.pageHomePage} onClick={() => menuClicked("home")}>
    //     <img src={logo} alt="IVC logo" height={"100px"} />
    //   </Link>
    //   <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    //       <span className="navbar-toggler-icon"></span>
    //     </button>
    //     <div className="collapse navbar-collapse" id="navbarNav">
    //     <ul className="navbar-nav">
    //         <li className="nav-item active">
    //           <Link to={"/create"} className="nav-link">
    //             Home
    //           </Link>
    //         </li>
    //         </ul>
    //   {viewList.view_loan_list && viewList.view_contract_list && (
    //     <div className="dropdown">
    //       <span className={"dropSpan " + loanMenu}>Loan</span>
    //       <div className="dropdown-content" style={{ width: "180px" }}>
    //         <span>Loan</span>
    //         {viewList.view_loan_list &&
    //           <Link to={pathnames.pageLoanApplicationList} onClick={() => menuClicked("loan")}>
    //             Loan Application
    //           </Link>
    //         }
    //         {viewList.view_contract_list && 
    //           <Link to={pathnames.pageLoanContractList} onClick={() => menuClicked("loan")}>
    //             Loan Contract
    //           </Link>
    //         }
    //       </div>
    //     </div>
    //   )}
    //   <div className="dropdown">
    //     <span className={"dropSpan " + databaseMenu}>Database</span>
    //     <div className="dropdown-content" style={{ width: "160px" }}>
    //       <span>Database</span>
    //       <Link to={pathnames.pageMerchantList} onClick={() => menuClicked("database")}>
    //         Merchant List
    //       </Link>
    //       {roles !== CONSTANSTS.ROLES.finance ?
    //       (<Link to={pathnames.pageCustomerList} onClick={() => menuClicked("database")}>
    //         {" "}
    //         Customer list
    //       </Link>)
    //       : ("")}
    //     </div>
    //   </div>
    //   <div className="dropdown">
    //     <span className={"dropSpan " + reportsMenu}>Reports</span>
    //     <div className="dropdown-content" style={{ width: "160px" }}>
    //       <span>Report</span>
    //       {roles === CONSTANSTS.ROLES.finance || roles === CONSTANSTS.ROLES.superAdmin || roles === CONSTANSTS.ROLES.masterAdmin ? (
    //       <Link to={pathnames.pagePayment} onClick={() => menuClicked("report")}>
    //         Payment
    //       </Link>
    //       ) : (
    //         ""
    //       )}
    //       {roles === CONSTANSTS.ROLES.finance || roles === CONSTANSTS.ROLES.superAdmin || roles === CONSTANSTS.ROLES.masterAdmin ? (
    //         <Link to={pathnames.pageTransaction} onClick={() => menuClicked("report")}>
    //           Transaction
    //         </Link>
    //       ) : (
    //         ""
    //       )}
    //       <Link to={pathnames.pageReportOthers} onClick={() => menuClicked("report")}>
    //         Others
    //       </Link>
    //     </div>
    //   </div>
    //   {isAuthorities && userMatrix.admin && (
    //     <div className="dropdown">
    //       <span className={"dropSpan " + adminMenu}>Admin Settings</span>
    //       <div className="dropdown-content" style={{ width: "230px" }}>
    //         <span>Admin Settings</span>
    //         <Link to={pathnames.pageLoanSettings} onClick={() => menuClicked("admin")}>
    //           Loan Settings
    //         </Link>
    //         <Link to={pathnames.pageCalendarSettings} onClick={() => menuClicked("admin")}>
    //           Calendar Settings
    //         </Link>
    //         <Link to={pathnames.pageApprovalMatrixSettings} onClick={() => menuClicked("admin")}>
    //           Approval Matrix Settings
    //         </Link>
    //         <Link to={pathnames.pageUserManagement} onClick={() => menuClicked("admin")}>
    //           User Management
    //         </Link>
    //       </div>
    //     </div>
    //   )}
    //   <div className="dropdown">
    //     <span className={"dropSpan " + userMenu} onClick={() => menuClicked("user")}>
    //       User Profile
    //     </span>
    //   </div>
    //   <div className="nav-bar__contents">
    //     <img onClick={logoutToggle} className="nav-bar__icon" src={iconLogout} alt="" />
    //     <span style={{ paddingLeft: "20px" }}>{packageJson.version}</span>
    //   </div>
    //   </div>
    // </nav>
  <nav className="navbar navbar-expand-lg navbar-dark bg-color">
  <div className="container-fluid" >
    <a className={"navbar-brand " + navBrand} href="#" >
      <div 
        // to={pathnames.pageHomePage} 
        onClick={() => menuClicked("home")}
      >
      <img src={logo} alt="IVC logo" height={"100px"} />
       </div>
    </a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
      {(viewList.view_loan_list || viewList.view_contract_list) && (
      <li className="nav-item dropdown dropSpan">
          <span className={"dropSpan " + loanMenu}aria-expanded="false">
            Loan
          </span>
          <ul className="dropdown-menu" style={{ width: "180px" }}>
          <span>Loan</span>
            <li >{viewList.view_loan_list &&
              <Link to={pathnames.pageLoanApplicationList} onClick={() => menuClicked("loan")}>
                Loan Application
              </Link>
              }
            </li>
            <li>{viewList.view_contract_list && 
              <Link to={pathnames.pageLoanContractList} onClick={() => menuClicked("loan")}>
                Loan Contract
              </Link>
            }
            </li>
          </ul>
        </li>
      )}
        <li className="nav-item dropdown dropSpan">
          <span className={"dropSpan " + databaseMenu} aria-expanded="false">
            Database
          </span>
          {roles !== CONSTANSTS.ROLES.executive ? (
          <ul className="dropdown-menu" style={{ width: "230px" }}>
          <span>Database</span>
           <li>{roles === CONSTANSTS.ROLES.superAdmin || roles === CONSTANSTS.ROLES.processOfficer || roles === CONSTANSTS.ROLES.creditOfficer || roles === CONSTANSTS.ROLES.masterAdmin  ? (
            <Link to={pathnames.pageMerchantDiscoverList} onClick={() => menuClicked("database")}>
                Merchant Discovery List
            </Link>
            ): ("")}</li>
            <li><Link to={pathnames.pageMerchantList} onClick={() => menuClicked("database")}>
                Merchant List
            </Link></li>
            <li>{roles !== CONSTANSTS.ROLES.finance ? (
            <Link to={pathnames.pageSignUpList} onClick={() => menuClicked("database")}>
            SignUp List
          </Link>
          ): ("")}</li>
          <li>{roles !== CONSTANSTS.ROLES.finance ?
          (<Link to={pathnames.pageCustomerList} onClick={() => menuClicked("database")}>
            {" "}
            Customer List
          </Link>)
          : ("")}</li>
          </ul>
          ): ("")}
        </li>
        <li className="nav-item dropdown dropSpan">
          <span className={"dropSpan " + reportsMenu}  aria-expanded="false">
            Reports
          </span>
          {roles !== CONSTANSTS.ROLES.executive ? (
          <ul className="dropdown-menu" style={{ width: "160px" }}>
          <span>Report</span>
          <li>{roles === CONSTANSTS.ROLES.finance || roles === CONSTANSTS.ROLES.superAdmin || roles === CONSTANSTS.ROLES.masterAdmin ? (
          <Link to={pathnames.pagePayment} onClick={() => menuClicked("report")}>
            Payment
          </Link>
          ):("")}</li>
            <li>{roles === CONSTANSTS.ROLES.finance || roles === CONSTANSTS.ROLES.superAdmin || roles === CONSTANSTS.ROLES.masterAdmin ? (
            <Link to={pathnames.pageTransaction} onClick={() => menuClicked("report")}>
              Transaction
            </Link>
          ):("")}</li>
          <li><Link to={pathnames.pageReportOthers} onClick={() => menuClicked("report")}>
              Others
         </Link></li>
          </ul>
          ): ("")}
        </li>
        {isAuthorities && userMatrix.admin && roles !== CONSTANSTS.ROLES.executive && (
        <li className="nav-item dropdown dropSpan">
          <span className={"dropSpan " + adminMenu}aria-expanded="false">
            Admin Settings
          </span>
          <ul className="dropdown-menu" style={{ width: "240px" }}>
          <span>Admin Settings</span>
            <li><Link to={pathnames.pageLoanSettings} onClick={() => menuClicked("admin")}>
               Loan Settings
            </Link></li>
            <li><Link to={pathnames.pageCalendarSettings} onClick={() => menuClicked("admin")}>
               Calendar Settings
            </Link></li>
            <li><Link to={pathnames.pageApprovalMatrixSettings} onClick={() => menuClicked("admin")}>
              Approval Matrix Settings
            </Link></li>
            <li><Link to={pathnames.pageUserManagement} onClick={() => menuClicked("admin")}>
               User Management
             </Link></li>
          </ul>
        </li>
        )}
        {isAuthorities && userMatrix.admin && roles === CONSTANSTS.ROLES.executive && (
        <li className="nav-item dropdown dropSpan">
          <span className={"dropSpan " + calendar} onClick={() => menuClicked("calendar")}>
            Calendar Settings
           {/* <Link to={pathnames.pageCalendarSettings} onClick={() => menuClicked("calendar")}>
               Calendar Settings
            </Link> */}
          </span>
        </li>
        )}
        <li className="nav-item dropdown dropSpan">
          <span className={"dropSpan " + userMenu} onClick={() => menuClicked("user")}>
             User Profile
          </span>
        </li>
      </ul>
      <div className="nav-bar__contents">
      <img onClick={logoutToggle} className="nav-bar__icon" src={iconLogout} alt="" />
      <span style={{ paddingLeft: "20px", color: "#f7f7f7"}}>{packageJson.version}</span>
      </div>
    </div>
  </div>
</nav>
  );
});

export default AppNav;
